import { render, staticRenderFns } from "./kycSettingsPage.vue?vue&type=template&id=1c96b9c1"
import script from "./kycSettingsPage.vue?vue&type=script&lang=js"
export * from "./kycSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports